var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgAluguer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "serv_aluguer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Board",
    transform: "translate(-2748.000000, -437.000000)",
    stroke: "",
    strokeWidth: 5.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv_aluguer",
    transform: "translate(2751.157481, 440.193349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5234364,53.0064567 L19.6459397,69.8481261 C18.4276063,71.1022927 16.0267721,71.8547919 14.3067721,71.6039586 L6.49510563,70.5289613 C3.91510553,70.170628 1.51427241,67.7339614 1.12010574,65.1539613 L0.0451059452,57.3422936 C-0.205727389,55.6222936 0.618439339,53.2214611 1.80093939,52.0031277 L18.6426056,35.1614583 C15.7759389,25.844792 17.9976062,15.2739585 25.3792727,7.92812534 C35.9501062,-2.64270816 53.114277,-2.64270816 63.7209438,7.92812534 C74.3276106,18.4989588 74.3276114,35.7347937 63.7567779,46.3056272 C56.3751115,53.6514603 45.8042694,55.9089567 36.5234364,53.0064567 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.5317383,
    y1: 55.4791158,
    x2: 25.7734039,
    y2: 63.7207866,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8008525,32.2233175 C41.8323219,32.2233175 39.4258525,29.816848 39.4258525,26.8483175 C39.4258525,23.8797869 41.8323219,21.4733175 44.8008525,21.4733175 C47.769383,21.4733175 50.1758525,23.8797869 50.1758525,26.8483175 C50.1758525,29.816848 47.769383,32.2233175 44.8008525,32.2233175 Z",
    id: "Vector"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAluguer);
export default __webpack_public_path__ + "static/media/svg_aluguer.09b8f5a22b0eeeac4ce442458f6a5dc0.svg";
export { ForwardRef as ReactComponent };